module.exports = __webpack_public_path__ + "assets/green-checkmark.a21ed175.svg";